/**
 * 키오스크 문구 조립 (BOOTH-28 → BOOTH-33). 문구 본문은 `@fiket/booth-schema` 의 COPY_CATALOG/DEFAULT_COPY 로 이관됐다.
 * `Strings` 는 카탈로그에서 파생된 중첩 타입 — 소비자는 여전히 `t.section.key`, 함수형 키는 `t.x.count(n)`.
 * 카탈로그에 없는 키를 쓰면 컴파일 에러, 카탈로그 키가 늘면 자동 반영.
 * params 인자는 number | string — 가격("5,000원")·남은 시간("02:47") 처럼 호출측이 포맷한 문자열도 받는다 (BOOTH-74).
 */
import type { CopyKey, CopyParamKey, CopySection } from "@fiket/booth-schema";
import { COPY_CATALOG, interpolate } from "@fiket/booth-schema";

type LeafOf<S extends string> = {
  [K in CopyKey as K extends `${S}.${infer R}` ? R : never]: K extends CopyParamKey ? (value: number | string) => string : string;
};

export type Strings = { [S in CopySection]: LeafOf<S> };

/** 평면 문구(resolveCopy 결과) → 중첩 Strings. params 키는 템플릿을 치환하는 함수로 감싼다. */
export function buildStrings(flat: Record<CopyKey, string>): Strings {
  const out: Record<string, Record<string, unknown>> = {};
  for (const entry of COPY_CATALOG) {
    const dot = entry.key.indexOf(".");
    const section = entry.key.slice(0, dot);
    const leaf = entry.key.slice(dot + 1);
    const template = flat[entry.key];
    const params = "params" in entry ? entry.params : undefined;
    (out[section] ??= {})[leaf] = params
      ? (value: number | string) => interpolate(template, { [params[0]]: value })
      : template;
  }
  return out as unknown as Strings;
}
